export default "__VITE_ASSET__f6d6cfe8__"